// export const URL_TWO = 'http://localhost:3001'
// export const URL_TWO = 'https://transpotrackserver.herokuapp.com'
// export const URL_TWO = 'https://transpotrackserver-production.up.railway.app';
export const URL_TWO = 'https://transpotrackserver.onrender.com'

//'adventurous-elk-getup.cyclic.app'
//https://transpotrackserver.herokuapp.com/